import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpXsrfTokenExtractor } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class XsrfInterceptor<T> implements HttpInterceptor {
  constructor(private tokenExtractor: HttpXsrfTokenExtractor) {}

  private XSRF_TOKEN_STRING: string = 'X-XSRF-TOKEN';
  private actions: string[] = ['GET', 'POST', 'PUT', 'DELETE'];
  private forbiddenActions: string[] = ['HEAD', 'OPTIONS'];

  intercept(request: HttpRequest<T>, next: HttpHandler): Observable<HttpEvent<T>> {
    const token = this.tokenExtractor.getToken();

    const permitted = this.findByActionName(request.method, this.actions);
    const forbidden = this.findByActionName(request.method, this.forbiddenActions);

    if (permitted !== undefined && forbidden === undefined && token !== null) {
      const xsrfTokenExists = request.headers.has(this.XSRF_TOKEN_STRING);
      if (!xsrfTokenExists) {
        request = request.clone({
          setHeaders: {
            [this.XSRF_TOKEN_STRING]: token
          }
        });
      }
    }

    return next.handle(request);
  }

  private findByActionName(name: string, actions: string[]): string | undefined {
    return actions.find((action) => action.toLocaleLowerCase() === name.toLocaleLowerCase());
  }

  private printDebugInfo(request: HttpRequest<T>) {
    console.log('Method: ' + request.method);
    console.log('URL with params: ' + request.urlWithParams);
    const headersString = request.headers.keys().reduce((acc, key) => {
      return acc + '   ' + key + ': ' + request.headers.get(key) + '\n';
    }
    , '');
    console.log('Headers' + '\n' + headersString);
  }
}
